/** Lendemain d'une date AAAA-MM-JJ, calculé en UTC pour ne pas dépendre
 * du fuseau du navigateur. */
export const nextIsoDay = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day + 1)).toISOString().slice(0, 10);
};

/** Bornes Ransack de la date de création d'une demande. `created_at` est
 * un horodatage : la borne haute s'exprime en « avant le lendemain » pour
 * inclure toute la journée choisie, `lteq` sur la date seule s'arrêtant à
 * minuit. L'API interprète la date dans le fuseau de Paris. */
export const createdAtRansackBounds = (
  from: string | null | undefined,
  to: string | null | undefined,
): Record<string, string> => {
  const bounds: Record<string, string> = {};
  if (from) bounds["q[created_at_gteq]"] = from;
  if (to) bounds["q[created_at_lt]"] = nextIsoDay(to);
  return bounds;
};
